import { Box, Menu, Tooltip } from '@mantine/core'

import { TaskPriority } from 'src/graphql/types/tasks'
import { formatSnakeValue } from 'src/lib/formatters'
import { PRIORITY_CONFIG } from 'src/lib/taskPriority'
import { cn } from 'src/utils'

import { MenuChevron, TASK_MENU_CLASSNAMES } from './taskMenuStyles'

const PriorityIcon = ({ priority }) => {
  const config = PRIORITY_CONFIG[priority]
  if (!config) return null
  const { Icon, color } = config
  return (
    <Box className={cn('flex items-center', color)}>
      <Icon className="h-4 w-4" />
    </Box>
  )
}

const PriorityMenu = ({ priority, setPriority }) => {
  return (
    <Menu
      offset={6}
      width={185}
      position="bottom-end"
      classNames={TASK_MENU_CLASSNAMES}
    >
      <Tooltip label={'Change priority'} position="top" className="text-xs">
        <Menu.Target>
          <div
            data-testid="priority-menu-trigger"
            className="flex cursor-pointer items-center gap-1 text-xs text-doubleNickel-gray-700 hover:text-doubleNickel-gray-900"
          >
            {formatSnakeValue(priority)}
            <PriorityIcon priority={priority} />
            <MenuChevron />
          </div>
        </Menu.Target>
      </Tooltip>

      <Menu.Dropdown>
        {Object.values(TaskPriority).map((value) => (
          <Menu.Item
            key={value}
            onClick={() => setPriority(value)}
            leftSection={<PriorityIcon priority={value} />}
          >
            {formatSnakeValue(value)}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  )
}

export default PriorityMenu
